<template>
	<span :endTime="endTime" :callback="callback" :endText="endText">
    <slot>
      {{content}}
    </slot>
  </span>
</template>
<script>
	export default {
		data() {
			return {
				content: '',
				before:0,
			}
		},
		watch: {
		    endTime(newValue, oldValue) {
		       this.countdowm(newValue)
		    }
		},
		props: {
			endTime: {
				type: String,
				default: ''
			},
			endText: {
				type: String,
				default: '已结束'
			},
			callback: {
				type: Function,
				default: ''
			}
		},
		mounted() {
			this.countdowm(this.endTime)
		},
		methods: {
			countdowm(timestamp) {
				let self = this,before=this.before
				let interval = setInterval(function() {
					console.log(interval,before)
					let beforeTime = new Date();
					let endTime = new Date(timestamp * 1000);
					let t = endTime.getTime() - beforeTime.getTime();
					if(t > 0) {
						let day = Math.floor(t / 86400000);
						let hour = Math.floor((t / 3600000) % 24);
						let min = Math.floor((t / 60000) % 60);
						let sec = Math.floor((t / 1000) % 60);
						hour = hour < 10 ? "0" + hour : hour;
						min = min < 10 ? "0" + min : min;
						sec = sec < 10 ? "0" + sec : sec;
						let format = '';
						if(day > 0) {
							format = `${day}天${hour}小时${min}分${sec}秒`;
						}
						if(day <= 0 && hour > 0) {
							format = `${hour}小时${min}分${sec}秒`;
						}
						if(day <= 0 && hour <= 0) {
							format = `${min}分${sec}秒`;
						}
						self.content = format;
					} else {
						clearInterval(interval);
						self.content = self.endText;
						self._callback();
					}
				}, 1000);
				if(interval>before){
					clearInterval(before);
					self.before=interval
				}
			},
			_callback() {
				if(this.callback && this.callback instanceof Function) {
					this.callback(...this);
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/countDown.vue